import { FunctionDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const UseFormState = () => (
  <FunctionDocs entry="useFormState">
    <ComponentExample
      name="Form state"
      import={import("examples/Forms/UseFormState/FormStateExample")}
      rawImport={import("examples/Forms/UseFormState/FormStateExample?raw")}
    />
  </FunctionDocs>
);

export default UseFormState;
